import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Upload, 
  X, 
  CheckCircle2, 
  AlertCircle, 
  Loader2, 
  ArrowLeft, 
  ShieldCheck, 
  Info,
  FileText,
  Camera,
  ChevronDown,
  ChevronUp,
  Star,
  Phone
} from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

// Localized translations dictionary
const local_t = {
  da: {
    back: "Tilbage",
    success_title: "VURDERING INDSENDT SUCCESFULDT!",
    success_desc: "Mange tak for din forespørgsel. Vi har modtaget dine biloplysninger og billeder. Vores eksperter vil nu vurdere din leasingbil uden registreringsafgift og moms, og du vil modtage et uforpligtende tilbud hurtigst muligt.",
    ref_id: "Reference ID",
    submit_new: "Indsend en ny forespørgsel",
    form_title: "Hvad er værdien af din leasingbil uden reg. afgift og moms?..",
    form_desc: "Udfyld formularen nedenfor med bilens specifikationer og stand. Vi køber udelukkende kun leasingbiler uden afgift og uden moms.",
    honeypot_label: "Efterlad dette felt tomt",
    error_occurred: "Der opstod en fejl:",
    sec1_title: "1. Bilens Basisoplysninger",
    vin_label: "Indtast venligst dit stelnummer eller registreringsnummer: *",
    vin_placeholder: "F.eks. WBA...",
    km_label: "Indtast venligst din kilometer-norm på bilen: *",
    km_placeholder: "F.eks. 65000",
    location_label: "Bilens placering: *",
    location_placeholder: "F.eks. Vejle, Aarhus, København",
    country_label: "Vælg registreringsland for din bil: *",
    country_choose: "— Vælg venligst en mulighed —",
    country_dk: "Danmark",
    country_se: "Sverige",
    country_de: "Tyskland",
    country_non_eu: "Ikke et europæisk land",
    equip_label: "Udstyrsvariant, farver m.m.: *",
    equip_placeholder: "Beskriv udstyr (f.eks. M-Sport, panorama, HUD), farve indvendig/udvendig...",
    sec2_title: "2. Afgift & Moms Status",
    ex_tax_label: "Er bilen ekskl. registreringsafgift?: *",
    ex_tax_opt1: "Ekskl. registreringsafgift - Ekskl. moms",
    ex_tax_opt2: "Ekskl. registreringsafgift",
    ex_tax_opt3: "Inklusive registreringsafgift - dem køber vi ikke",
    vat_label: "Er bilen + Moms, eller Momsfri?: *",
    vat_choose: "— Vælg venligst en mulighed —",
    vat_opt1: "Med 25% løftbar moms",
    vat_opt2: "Momsdød - momsfri, ingen adgang til momsfradrag",
    info_box: "Vi køber udelukkende kun leasingbiler uden afgift og uden moms for at sikre den mest optimale eksportværdi.",
    sec3_title: "3. Bilens Stand & Mekanik",
    mech_label: "Mekanisk eller elektrisk fejl?: *",
    mech_choose: "— Vælg venligst en mulighed —",
    mech_opt1: "Har mekanisk fejl",
    mech_opt2: "Har elektrisk fejl",
    mech_opt3: "Bilen har ikke mekanisk eller elektrisk fejl",
    windshield_label: "Hvad er status på forruden?: *",
    windshield_choose: "— Vælg venligst en mulighed —",
    windshield_opt1: "Fejlfri",
    windshield_opt2: "Stenslag",
    windshield_opt3: "Flænge",
    paint_label: "Hvor mange felter til lak?: *",
    paint_choose: "— Vælg venligst en mulighed —",
    paint_opt0: "0 - Som ny bil!",
    transport_label: "Kan køretøjet bremse, håndbremse, køre og bakke på autotransport?: *",
    transport_choose: "— Vælg venligst en mulighed —",
    transport_yes: "Ja",
    transport_no: "Nej - (Auto Logik A/S - MED SPIL VOGN)",
    remarks_label: "Bemærkninger:",
    remarks_placeholder: "Yderligere detaljer om bilens stand, servicehistorik eller andet...",
    sec4_title: "Vedhæft billeder af bilen (minimum 3 billeder): *",
    upload_click: "Klik for at uploade billeder",
    upload_desc: "PDF, PNG, JPEG, GIF eller WEBP (Maks 10 MB pr. fil, 20 MB totalt)",
    remove_file: "Fjern fil",
    sec5_title: "KONTAKTOPLYSNINGER",
    name_label: "Navn *",
    name_placeholder: "Dit fulde navn",
    phone_label: "Telefon *",
    phone_placeholder: "F.eks. +45 12 34 56 78",
    email_label: "Email *",
    email_placeholder: "din@email.dk",
    sec6_title: "Hvad er 12 + 48? *",
    math_desc: "Bekræft venligst, at du er et menneske ved at vælge det rigtige svar.",
    math_choose: "— Vælg et svar —",
    consent_text: "Ja, jeg giver tilladelse til, at Vejle AutoExport må kontakte mig på enten mail eller telefon samt behandle ovenstående persondata i overensstemmelse med vores vilkår for behandling af personoplysninger. Vi opbevarer dine persondata, indtil du tilbagekalder dit samtykke.*",
    submitting: "Indsender vurdering...",
    submit_btn: "FÅ VURDERING UDEN AFGIFT",
    secure_data: "100% sikker og krypteret dataoverførsel",
    reviews_title: "VI LADER KUNDER SNAKKE FOR OS...",
    reviews_desc: "Google samlet bedømmelse er 4.6 af 5, på basis af 69 bedømmelser",
    faq_title: "FÅ SVAR PÅ DINE SPØRGSMÅL...",
    cta_title: "Har du nogle spørgsmål, som VI kan hjælpe dig med?",
    cta_desc: "Du er altid velkommen til at kontakte os. Vi står klar til at rådgive dig – uanset om du overvejer at sælge din bil eller blot ønsker at høre om dine muligheder.",
    cta_btn: "Skriv til os",
    alert_max_files: "Du kan højst vedhæfte 5 filer i alt.",
    alert_invalid_type: "Filtypen er ikke tilladt. Kun PDF, PNG, JPEG, GIF og WEBP understøttes.",
    alert_file_too_large: "Filen er for stor. Maksimal størrelse pr. fil is 10 MB.",
    alert_total_size: "Den samlede størrelse af alle filer overstiger grænsen på 20 MB.",
    alert_min_images: "Vedhæft venligst minimum 3 billeder af bilen.",
    alert_wrong_math: "Det matematiske kontrolspørgsmål er besvaret forkert. Prøv igen.",
    alert_consent: "Du skal give samtykke til behandling af dine persondata for at indsende formularen.",
    network_error: "Netværksfejl. Kontroller din internetforbindelse og prøv igen.",
    default_error: "Der opstod en fejl under indsendelsen. Prøv venligst igen."
  },
  en: {
    back: "Back",
    success_title: "VALUATION SUBMITTED SUCCESSFULLY!",
    success_desc: "Thank you very much for your inquiry. We have received your car details and images. Our experts will now evaluate your leasing car without registration tax and VAT, and you will receive a non-binding offer as soon as possible.",
    ref_id: "Reference ID",
    submit_new: "Submit a new inquiry",
    form_title: "What is the value of your leasing car without registration tax and VAT?..",
    form_desc: "Fill out the form below with the car's specifications and condition. We exclusively buy leasing cars without tax and without VAT.",
    honeypot_label: "Leave this field empty",
    error_occurred: "An error occurred:",
    sec1_title: "1. Basic Car Information",
    vin_label: "Please enter your VIN (chassis number) or registration number: *",
    vin_placeholder: "E.g. WBA...",
    km_label: "Please enter the current mileage of the car: *",
    km_placeholder: "E.g. 65000",
    location_label: "Car location: *",
    location_placeholder: "E.g. Vejle, Aarhus, Copenhagen",
    country_label: "Select registration country for your car: *",
    country_choose: "— Please choose an option —",
    country_dk: "Denmark",
    country_se: "Sweden",
    country_de: "Germany",
    country_non_eu: "Not a European country",
    equip_label: "Equipment variant, colors, etc.: *",
    equip_placeholder: "Describe equipment (e.g. M-Sport, panorama, HUD), interior/exterior color...",
    sec2_title: "2. Tax & VAT Status",
    ex_tax_label: "Is the car excluding registration tax?: *",
    ex_tax_opt1: "Excl. registration tax - Excl. VAT",
    ex_tax_opt2: "Excl. registration tax",
    ex_tax_opt3: "Including registration tax - we do not buy these",
    vat_label: "Is the car + VAT, or VAT-free?: *",
    vat_choose: "— Please choose an option —",
    vat_opt1: "With 25% reclaimable VAT",
    vat_opt2: "VAT-dead - VAT-free, no access to VAT deduction",
    info_box: "We exclusively buy leasing cars without tax and without VAT to ensure the most optimal export value.",
    sec3_title: "3. Car Condition & Mechanics",
    mech_label: "Mechanical or electrical fault?: *",
    mech_choose: "— Please choose an option —",
    mech_opt1: "Has mechanical fault",
    mech_opt2: "Has electrical fault",
    mech_opt3: "The car has no mechanical or electrical faults",
    windshield_label: "What is the status of the windshield?: *",
    windshield_choose: "— Please choose an option —",
    windshield_opt1: "Flawless",
    windshield_opt2: "Stone chip",
    windshield_opt3: "Crack",
    paint_label: "How many panels need painting?: *",
    paint_choose: "— Please choose an option —",
    paint_opt0: "0 - Like a new car!",
    transport_label: "Can the vehicle brake, handbrake, drive, and reverse onto auto transport?: *",
    transport_choose: "— Please choose an option —",
    transport_yes: "Yes",
    transport_no: "No - (Auto Logik A/S - WITH WINCH TRUCK)",
    remarks_label: "Remarks:",
    remarks_placeholder: "Additional details about the car's condition, service history, or other...",
    sec4_title: "Attach pictures of the car (minimum 3 pictures): *",
    upload_click: "Click to upload pictures",
    upload_desc: "PDF, PNG, JPEG, GIF or WEBP (Max 10 MB per file, 20 MB total)",
    remove_file: "Remove file",
    sec5_title: "CONTACT INFORMATION",
    name_label: "Name *",
    name_placeholder: "Your full name",
    phone_label: "Phone *",
    phone_placeholder: "E.g. +45 12 34 56 78",
    email_label: "Email *",
    email_placeholder: "your@email.com",
    sec6_title: "What is 12 + 48? *",
    math_desc: "Please confirm that you are a human by selecting the correct answer.",
    math_choose: "— Choose an answer —",
    consent_text: "Yes, I authorize Vejle AutoExport to contact me by either email or phone and to process the above personal data in accordance with our terms for processing personal data. We store your personal data until you withdraw your consent.*",
    submitting: "Submitting valuation...",
    submit_btn: "GET VALUATION WITHOUT TAX",
    secure_data: "100% secure and encrypted data transfer",
    reviews_title: "WE LET CUSTOMERS DO THE TALKING...",
    reviews_desc: "Google overall rating is 4.6 out of 5, based on 69 reviews",
    faq_title: "GET ANSWERS TO YOUR QUESTIONS...",
    cta_title: "Do you have any questions that WE can help you with?",
    cta_desc: "You are always welcome to contact us. We are ready to advise you – whether you are considering selling your car or just want to hear about your options.",
    cta_btn: "Write to us",
    alert_max_files: "You can attach a maximum of 5 files in total.",
    alert_invalid_type: "The file type is not allowed. Only PDF, PNG, JPEG, GIF, and WEBP are supported.",
    alert_file_too_large: "The file is too large. Maximum size per file is 10 MB.",
    alert_total_size: "The total size of all files exceeds the limit of 20 MB.",
    alert_min_images: "Please attach at least 3 pictures of the car.",
    alert_wrong_math: "The mathematical verification question was answered incorrectly. Please try again.",
    alert_consent: "You must give consent to the processing of your personal data to submit the form.",
    network_error: "Network error. Please check your internet connection and try again.",
    default_error: "An error occurred during submission. Please try again."
  },
  de: {
    back: "Zurück",
    success_title: "BEWERTUNG ERFOLGREICH ÜBERMITTELT!",
    success_desc: "Vielen Dank für Ihre Anfrage. Wir haben Ihre Fahrzeugdaten und Bilder erhalten. Unsere Experten werden nun Ihr Leasingfahrzeug ohne Zulassungssteuer und MwSt. bewerten, und Sie erhalten so schnell wie möglich ein unverbindliches Angebot.",
    ref_id: "Referenz-ID",
    submit_new: "Eine neue Anfrage senden",
    form_title: "Was ist der Wert Ihres Leasingfahrzeugs ohne Zulassungssteuer und MwSt.?..",
    form_desc: "Füllen Sie das folgende Formular mit den Spezifikationen und dem Zustand des Fahrzeugs aus. Wir kaufen ausschließlich Leasingfahrzeuge ohne Steuer und ohne MwSt.",
    honeypot_label: "Lassen Sie dieses Feld leer",
    error_occurred: "Ein Fehler ist aufgetreten:",
    sec1_title: "1. Basisdaten des Fahrzeugs",
    vin_label: "Bitte geben Sie Ihre Fahrgestellnummer (FIN) oder Ihr Kennzeichen ein: *",
    vin_placeholder: "Z.B. WBA...",
    km_label: "Bitte geben Sie den aktuellen Kilometerstand des Fahrzeugs ein: *",
    km_placeholder: "Z.B. 65000",
    location_label: "Standort des Fahrzeugs: *",
    location_placeholder: "Z.B. Vejle, Aarhus, Kopenhagen",
    country_label: "Wählen Sie das Zulassungsland für Ihr Fahrzeug: *",
    country_choose: "— Bitte wählen Sie eine Option —",
    country_dk: "Dänemark",
    country_se: "Schweden",
    country_de: "Deutschland",
    country_non_eu: "Kein europäisches Land",
    equip_label: "Ausstattungsvariante, Farben usw.: *",
    equip_placeholder: "Ausstattung beschreiben (z. B. M-Sport, Panorama, HUD), Innen-/Ausßenfarbe...",
    sec2_title: "2. Steuer- & MwSt.-Status",
    ex_tax_label: "Ist das Fahrzeug ohne Zulassungssteuer?: *",
    ex_tax_opt1: "Ohne Zulassungssteuer - Ohne MwSt.",
    ex_tax_opt2: "Ohne Zulassungssteuer",
    ex_tax_opt3: "Inklusive Zulassungssteuer - diese kaufen wir nicht",
    vat_label: "Ist das Fahrzeug + MwSt. oder MwSt.-frei?: *",
    vat_choose: "— Bitte wählen Sie eine Option —",
    vat_opt1: "Mit 25% ausweisbarer MwSt.",
    vat_opt2: "Differenzbesteuert - MwSt.-frei, kein Vorsteuerabzug möglich",
    info_box: "Wir kaufen ausschließlich Leasingfahrzeuge ohne Steuer und ohne MwSt., um den optimalen Exportwert zu gewährleisten.",
    sec3_title: "3. Fahrzeugzustand & Mechanik",
    mech_label: "Mechanischer oder elektrischer Fehler?: *",
    mech_choose: "— Bitte wählen Sie eine Option —",
    mech_opt1: "Hat mechanischen Fehler",
    mech_opt2: "Hat elektrischen Fehler",
    mech_opt3: "Das Fahrzeug hat keine mechanischen oder elektrischen Fehler",
    windshield_label: "Wie ist der Zustand der Windschutzscheibe?: *",
    windshield_choose: "— Bitte wählen Sie eine Option —",
    windshield_opt1: "Einwandfrei",
    windshield_opt2: "Steinschlag",
    windshield_opt3: "Riss",
    paint_label: "Wie viele Teile müssen lackiert werden?: *",
    paint_choose: "— Bitte wählen Sie eine Option —",
    paint_opt0: "0 - Wie ein Neuwagen!",
    transport_label: "Kann das Fahrzeug bremsen, Handbremse betätigen, vorwärts und rückwärts auf den Autotransporter fahren?: *",
    transport_choose: "— Bitte wählen Sie eine Option —",
    transport_yes: "Ja",
    transport_no: "Nein - (Auto Logik A/S - MIT SEILWINDE)",
    remarks_label: "Bemerkungen:",
    remarks_placeholder: "Weitere Details zum Zustand des Fahrzeugs, zur Servicehistorie oder Sonstiges...",
    sec4_title: "Bilder des Fahrzeugs anhängen (mindestens 3 Bilder): *",
    upload_click: "Klicken Sie hier, um Bilder hochzuladen",
    upload_desc: "PDF, PNG, JPEG, GIF oder WEBP (Max. 10 MB pro Datei, 20 MB insgesamt)",
    remove_file: "Datei entfernen",
    sec5_title: "KONTAKTINFORMATIONEN",
    name_label: "Name *",
    name_placeholder: "Ihr vollständiger Name",
    phone_label: "Telefon *",
    phone_placeholder: "Z.B. +49 123 456789",
    email_label: "E-Mail *",
    email_placeholder: "ihre@email.de",
    sec6_title: "Was ist 12 + 48? *",
    math_desc: "Bitte bestätigen Sie, dass Sie ein Mensch sind, indem Sie die richtige Antwort auswählen.",
    math_choose: "— Wählen Sie eine Antwort —",
    consent_text: "Ja, ich ermächtige Vejle AutoExport, mich entweder per E-Mail oder Telefon zu kontaktieren und die oben genannten personenbezogenen Daten gemäß unseren Bedingungen für die Verarbeitung personenbezogener Daten zu verarbeiten. Wir speichern Ihre personenbezogenen Daten, bis Sie Ihre Einwilligung widerrufen.*",
    submitting: "Bewertung wird übermittelt...",
    submit_btn: "BEWERTUNG OHNE STEUER ERHALTEN",
    secure_data: "100% sichere und verschlüsselte Datenübertragung",
    reviews_title: "WIR LASSEN UNSERE KUNDEN SPRECHEN...",
    reviews_desc: "Die Google-Gesamtbewertung beträgt 4.6 von 5, basierend auf 69 Bewertungen",
    faq_title: "ERHALTEN SIE ANTWORTEN AUF IHRE FRAGEN...",
    cta_title: "Haben Sie Fragen, bei denen WIR Ihnen helfen können?",
    cta_desc: "Sie können uns jederzeit gerne kontaktieren. Wir stehen Ihnen beratend zur Seite – egal, ob Sie den Verkauf Ihres Autos in Erwägung ziehen oder sich einfach über Ihre Möglichkeiten informieren möchten.",
    cta_btn: "Schreiben Sie uns",
    alert_max_files: "Sie können insgesamt maximal 5 Dateien anhängen.",
    alert_invalid_type: "Der Dateityp ist nicht zulässig. Nur PDF, PNG, JPEG, GIF und WEBP werden unterstützt.",
    alert_file_too_large: "Die Datei ist zu groß. Die maximale Größe pro Datei beträgt 10 MB.",
    alert_total_size: "Die Gesamtgröße aller Dateien überschreitet das Limit von 20 MB.",
    alert_min_images: "Bitte hängen Sie mindestens 3 Bilder des Fahrzeugs an.",
    alert_wrong_math: "Die mathematische Kontrollfrage wurde falsch beantwortet. Bitte versuchen Sie es erneut.",
    alert_consent: "Sie müssen der Verarbeitung Ihrer personenbezogenen Daten zustimmen, um das Formular abzusenden.",
    network_error: "Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    default_error: "Bei der Übermittlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
  }
};

// Localized reviews data
const localizedReviews = {
  da: [
    {
      name: 'Joan Nielsen',
      date: '21. Maj 2025',
      text: 'Virkelig god oplevelse. Rigtig god og kompetent hjælp fra start til slut. Kan varmt anbefales at bruge dette firma.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/8ac2c1ee-0014-4737-a906-543800bc5d34.png'
    },
    {
      name: 'Christian Sohl',
      date: '4. April 2025',
      text: 'Rigtig fin oplevelse i forbindelse med salg af bil. God kommunikation og hurtig betaling efter aftale. Afhentning efter betaling. Kan anbefales.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/a1e40a59-0eff-4395-8555-ca747f94761f.png'
    },
    {
      name: 'Peter Halling Bruun',
      date: '23. Marts 2025',
      text: 'Sami Kobeita er en meget flink og troværdig mand, og jeg kan kun sige positive ting. Alt gik helt efter bogen, og jeg købte en meget velholdt bil. Sami får mine varmeste anbefalinger!',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/d495e025-0579-4902-9c36-031440725213.png'
    },
    {
      name: 'matilde kvist',
      date: '12. Oktober 2024',
      text: 'Stor hjælp ved salg af bil, sød, venlig og ærlig',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/b4eafa97-f84f-4510-9973-df4b7e846c50.png'
    },
    {
      name: 'Nae Burlacu',
      date: '22. April 2025',
      text: 'Fremragende kommunikation, venlige, kan varmt anbefales.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/51d5c5f1-1c83-4daa-ba96-91ec5d002c1f.png'
    },
    {
      name: 'Mădălin Pirvu',
      date: '22. Marts 2025',
      text: 'Folk af høj kvalitet, super gode og top service, anbefaler med fuld tillid!',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/0bc167e0-c638-4d6f-bbc6-0fda6a5a881f.png'
    }
  ],
  en: [
    {
      name: 'Joan Nielsen',
      date: 'May 21, 2025',
      text: 'Really great experience. Very good and competent help from start to finish. Highly recommend using this company.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/8ac2c1ee-0014-4737-a906-543800bc5d34.png'
    },
    {
      name: 'Christian Sohl',
      date: 'April 4, 2025',
      text: 'Very nice experience in connection with selling a car. Good communication and fast payment as agreed. Pickup after payment. Recommended.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/a1e40a59-0eff-4395-8555-ca747f94761f.png'
    },
    {
      name: 'Peter Halling Bruun',
      date: 'March 23, 2025',
      text: 'Sami Kobeita is a very nice and trustworthy man, and I can only say positive things. Everything went exactly by the book, and I bought a very well-maintained car. Sami gets my warmest recommendations!',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/d495e025-0579-4902-9c36-031440725213.png'
    },
    {
      name: 'matilde kvist',
      date: 'October 12, 2024',
      text: 'Great help with selling the car, sweet, friendly and honest',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/b4eafa97-f84f-4510-9973-df4b7e846c50.png'
    },
    {
      name: 'Nae Burlacu',
      date: 'April 22, 2025',
      text: 'Excellent communication, friendly, highly recommended.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/51d5c5f1-1c83-4daa-ba96-91ec5d002c1f.png'
    },
    {
      name: 'Mădălin Pirvu',
      date: 'March 22, 2025',
      text: 'High quality people, super good and top services, recommend with full confidence!',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/0bc167e0-c638-4d6f-bbc6-0fda6a5a881f.png'
    }
  ],
  de: [
    {
      name: 'Joan Nielsen',
      date: '21. Mai 2025',
      text: 'Wirklich tolle Erfahrung. Sehr gute und kompetente Hilfe von Anfang bis Ende. Kann dieses Unternehmen wärmstens empfehlen.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/8ac2c1ee-0014-4737-a906-543800bc5d34.png'
    },
    {
      name: 'Christian Sohl',
      date: '4. April 2025',
      text: 'Sehr schöne Erfahrung im Zusammenhang mit dem Autoverkauf. Gute Kommunikation und schnelle Bezahlung wie vereinbart. Abholung nach Zahlung. Empfehlenswert.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/a1e40a59-0eff-4395-8555-ca747f94761f.png'
    },
    {
      name: 'Peter Halling Bruun',
      date: '23. März 2025',
      text: 'Ich komme aus Dänemark, und ich habe mein Auto bei Vejle Auto Export gekauft. Es war ein sehr gutes Erlebnis. Sami Kobeita ist einen sehr netter und vertrauenswürdiger Mann, und ich kann nur Positives berichten. 💪🤠 Alles lief genau nach Vorschrift und ich habe ein sehr gepflegtes Auto gekauft. 🚙😃 Sami bekommt meine wärmsten Empfehlungen! 😎 Vielen Dank für eine wirklich gute Abwicklung! 🙏 5 Sterne von mir - gerne wieder… 🤩',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/d495e025-0579-4902-9c36-031440725213.png'
    },
    {
      name: 'matilde kvist',
      date: '12. Oktober 2024',
      text: 'Große Hilfe beim Autoverkauf, süß, freundlich und ehrlich',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/b4eafa97-f84f-4510-9973-df4b7e846c50.png'
    },
    {
      name: 'Nae Burlacu',
      date: '22. April 2025',
      text: 'Exzellente Kommunikation, freundlich, sehr zu empfehlen.',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/51d5c5f1-1c83-4daa-ba96-91ec5d002c1f.png'
    },
    {
      name: 'Mădălin Pirvu',
      date: '22. März 2025',
      text: 'Qualitativ hochwertige Leute, super gute und erstklassige Dienstleistungen, empfehle ich mit vollem Vertrauen!',
      img: 'https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/0bc167e0-c638-4d6f-bbc6-0fda6a5a881f.png'
    }
  ]
};

// Localized FAQ data
const localizedFaqs = {
  da: [
    {
      q: 'Hvilke typer biler arbejder vi med?',
      a: `<h3><strong>Vi køber primært biler fra 2010 til og med 2022</strong></h3>
          <p><strong>Vi er særligt interesserede i følgende typer køretøjer:</strong></p>
          <ul>
            <li>Leasingbiler (ex moms og afgift – meget populære)</li>
            <li>Køretøjer i premium-klassen</li>
            <li>Køretøjer i luksusklassen</li>
            <li>Firehjulstrækkere</li>
            <li>Køretøjer til handicappede</li>
            <li>Pansrede køretøjer</li>
            <li>Rustvogne</li>
            <li>Sportskøretøjer</li>
            <li>Varevogne</li>
          </ul>
          <p>Kontakt os gerne for et uforpligtende tilbud, hvis du har en bil, der matcher ovenstående!</p>`
    },
    {
      q: 'Hvad gør Vejle Auto Export til det bedste valg for at opnå den bedste pris for min bil?',
      a: `<h3><strong>Stærkt Netværk – Gode Priser</strong></h3>
          <p>Vejle Auto Export samarbejder med cirka 3.000 opkøbere gennem vores omfattende kundekartotek, som vi har opbygget siden 2007. Dette brede netværk giver os mulighed for at tilbyde dig en særdeles attraktiv pris for din bil.</p>`
    },
    {
      q: 'Kan jeg købe en bil hos Vejle Auto Export?',
      a: `<h3><strong>Fokus på Opkøb og Export – Ikke Detailsalg</strong></h3>
          <p>Vejle Auto Export fokuserer udelukkende på opkøb af kunders biler og eksport af disse til udlandet. Vi tilbyder næsten ikke salg af biler til privatkunder i Danmark. Vores primære mål er at hjælpe dig med en problemfri og konkurrencedygtig handel, når du ønsker at sælge eller eksportere din bil.</p>`
    },
    {
      q: 'Hvordan foregår det, når jeg sælger min bil til Vejle Auto Export?',
      a: `<h3><strong>Sådan Sælger du din Bil til Vejle Auto Export</strong></h3>
          <p>Salget af din bil til Vejle Auto Export er enkelt, hurtigt og bekvemt. Du kan kontakte os via vores hjemmeside under “SÆLG DIN BIL”, telefonisk eller på e-mail.</p>
          <h4><strong>Sådan foregår processen:</strong></h4>
          <ol>
            <li>Du sender en forespørgsel</li>
            <li>Vi sender et tilbud</li>
            <li>Ved accept godkender vi og overfører pengene til dig</li>
            <li>Vi afhenter bilen hos dig</li>
            <li>Vi tager os af al kontakt til SKAT</li>
          </ol>
          <p>Vi tilbyder dig en pris uden fysisk inspektion af din bil. Når vi har godkendt oplysningerne, sørger vi for al nødvendigt papirarbejde, herunder købskontrakt og dokumentation. Der foretages straksbetaling direkte til din bankkonto, så snart købskontrakten er underskrevet.</p>
          <p>Når du har bekræftet, at du har modtaget betalingen, planlægger vi afhentning af bilen.</p>
          <h4>Afhentning med Dansk AutoLogik</h4>
          <p>Vores samarbejdspartner, Dansk AutoLogik (<a href="http://www.autologik.dk/" target="_blank" rel="noopener noreferrer" class="underline">Www.Autologik.dk</a>), afhenter bilen på din adresse inden for 1-3 hverdage efter modtaget indbetaling. Du får besked én dag før afhentningen.</p>
          <h4>Nummerplader</h4>
          <p>Hvis nummerpladerne stadig sidder på bilen på afhentningsdagen, afmelder vi dem for dig uden ekstra omkostning.</p>`
    }
  ],
  en: [
    {
      q: 'What types of cars do we work with?',
      a: `<h3><strong>We primarily buy cars from 2010 up to and including 2022</strong></h3>
          <p><strong>We are particularly interested in the following types of vehicles:</strong></p>
          <ul>
            <li>Leasing cars (ex VAT and registration tax – very popular)</li>
            <li>Premium class vehicles</li>
            <li>Luxury class vehicles</li>
            <li>Four-wheel drives (4x4)</li>
            <li>Vehicles for disabled persons</li>
            <li>Armored vehicles</li>
            <li>Hearses</li>
            <li>Sports vehicles</li>
            <li>Vans</li>
          </ul>
          <p>Feel free to contact us for a non-binding offer if you have a car that matches the above!</p>`
    },
    {
      q: 'What makes Vejle Auto Export the best choice to get the best price for my car?',
      a: `<h3><strong>Strong Network – Great Prices</strong></h3>
          <p>Vejle Auto Export cooperates with approximately 3,000 buyers through our extensive customer database, which we have built since 2007. This wide network allows us to offer you a highly attractive price for your car.</p>`
    },
    {
      q: 'Can I buy a car from Vejle Auto Export?',
      a: `<h3><strong>Focus on Purchase and Export – Not Retail Sales</strong></h3>
          <p>Vejle Auto Export focuses exclusively on purchasing customer cars and exporting them abroad. We rarely offer car sales to private customers in Denmark. Our primary goal is to help you with a hassle-free and competitive transaction when you want to sell or export your car.</p>`
    },
    {
      q: 'How does it work when I sell my car to Vejle Auto Export?',
      a: `<h3><strong>How to Sell Your Car to Vejle Auto Export</strong></h3>
          <p>Selling your car to Vejle Auto Export is simple, fast, and convenient. You can contact us via our website under "SELL YOUR CAR", by phone, or by email.</p>
          <h4><strong>How the process works:</strong></h4>
          <ol>
            <li>You send an inquiry</li>
            <li>We send an offer</li>
            <li>Upon acceptance, we approve and transfer the money to you</li>
            <li>We pick up the car from your address</li>
            <li>We handle all contact with SKAT (Danish Tax Agency)</li>
          </ol>
          <p>We offer you a price without a physical inspection of your car. Once we have approved the details, we take care of all necessary paperwork, including the purchase contract and documentation. An instant payment is made directly to your bank account as soon as the purchase contract is signed.</p>
          <p>Once you have confirmed receipt of payment, we schedule the pickup of the car.</p>
          <h4>Pickup with Dansk AutoLogik</h4>
          <p>Our partner, Dansk AutoLogik (<a href="http://www.autologik.dk/" target="_blank" rel="noopener noreferrer" class="underline">Www.Autologik.dk</a>), picks up the car at your address within 1-3 business days after payment is received. You will be notified one day prior to pickup.</p>
          <h4>License Plates</h4>
          <p>If the license plates are still on the car on the day of pickup, we will deregister them for you at no extra cost.</p>`
    }
  ],
  de: [
    {
      q: 'Mit welchen Fahrzeugtypen arbeiten wir?',
      a: `<h3><strong>Wir kaufen hauptsächlich Fahrzeuge der Baujahre 2010 bis einschließlich 2022</strong></h3>
          <p><strong>Besonders interessiert sind wir an folgenden Fahrzeugtypen:</strong></p>
          <ul>
            <li>Leasingfahrzeuge (ohne MwSt. und Zulassungssteuer – sehr beliebt)</li>
            <li>Fahrzeuge der Premiumklasse</li>
            <li>Fahrzeuge der Luxusklasse</li>
            <li>Allradfahrzeuge (4x4)</li>
            <li>Behindertengerechte Fahrzeuge</li>
            <li>Gepanzerte Fahrzeuge</li>
            <li>Leichenwagen</li>
            <li>Sportwagen</li>
            <li>Transporter</li>
          </ul>
          <p>Kontaktieren Sie uns gerne für ein unverbindliches Angebot, wenn Sie ein passendes Fahrzeug haben!</p>`
    },
    {
      q: 'Was macht Vejle Auto Export zur besten Wahl, um den besten Preis für mein Auto zu erzielen?',
      a: `<h3><strong>Starkes Netzwerk – Gute Preise</strong></h3>
          <p>Vejle Auto Export arbeitet mit rund 3.000 Einkäufern über unsere umfangreiche Kundendatenbank zusammen, die wir seit 2007 aufgebaut haben. Dieses breite Netzwerk ermöglicht es uns, Ihnen einen äußerst attraktiven Preis für Ihr Auto anzubieten.</p>`
    },
    {
      q: 'Kann ich bei Vejle Auto Export ein Auto kaufen?',
      a: `<h3><strong>Fokus auf Ankauf und Export – Kein Einzelhandel</strong></h3>
          <p>Vejle Auto Export konzentriert sich ausschließlich auf den Ankauf von Kundenfahrzeugen und deren Export ins Ausland. Wir bieten fast keinen Autoverkauf an Privatkunden in Dänemark an. Unser Hauptziel ist es, Ihnen bei einem reibungslosen und wettbewerbsfähigen Geschäft zu helfen, wenn Sie Ihr Auto verkaufen oder exportieren möchten.</p>`
    },
    {
      q: 'Wie läuft der Verkauf meines Autos an Vejle Auto Export ab?',
      a: `<h3><strong>So verkaufen Sie Ihr Auto an Vejle Auto Export</strong></h3>
          <p>Der Verkauf Ihres Autos an Vejle Auto Export ist einfach, schnell und bequem. Sie können uns über unsere Website unter „AUTO VERKAUFEN“, telefonisch oder per E-Mail kontaktieren.</p>
          <h4><strong>So läuft der Prozess ab:</strong></h4>
          <ol>
            <li>Sie senden eine Anfrage</li>
            <li>Sie erhalten ein Angebot</li>
            <li>Nach der Annahme genehmigen wir und überweisen Ihnen das Geld</li>
            <li>Wir holen das Auto bei Ihnen ab</li>
            <li>Wir kümmern uns um den gesamten Kontakt mit der dänischen Steuerbehörde (SKAT)</li>
          </ol>
          <p>Wir bieten Ihnen einen Preis ohne physische Besichtigung Ihres Autos an. Sobald wir die Angaben freigegeben haben, kümmern wir uns um den gesamten notwendigen Papierkram, einschließlich Kaufvertrag und Dokumentation. Eine Sofortüberweisung erfolgt direkt auf Ihr Bankkonto, sobald der Kaufvertrag unterzeichnet ist.</p>
          <p>Sobald Sie den Zahlungseingang bestätigt haben, planen wir die Abholung des Fahrzeugs.</p>
          <h4>Abholung mit Dansk AutoLogik</h4>
          <p>Unser Partner Dansk AutoLogik (<a href="http://www.autologik.dk/" target="_blank" rel="noopener noreferrer" class="underline">Www.Autologik.dk</a>) holt das Auto innerhalb von 1-3 Werktagen nach Zahlungseingang an Ihrer Adresse ab. Sie werden einen Tag vor der Abholung benachrichtigt.</p>
          <h4>Kennzeichen</h4>
          <p>Sollten sich am Abholtag noch Kennzeichen am Fahrzeug befinden, melden wir diese kostenlos für Sie ab.</p>`
    }
  ]
};

export default function SellLeasingCarPage() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { language } = useLanguage();

  // Translation helper function
  const lt = (key) => local_t[language]?.[key] || local_t['da']?.[key] || key;

  // Form states
  const [formData, setFormData] = useState({
    stelnummer_eller_reg: '',
    kilometer_norm: '',
    udstyrsvariant_farver: '',
    bilens_placering: '',
    registreringsland: '',
    ekskl_registreringsafgift: '',
    moms_status: '',
    mekanisk_elektrisk_fejl: '',
    forrude_status: '',
    lak_felter: '',
    autotransport_egnet: '',
    bemaerkninger: '',
    navn: '',
    telefon: '',
    email: '',
    math_answer: '',
    samtykke: false,
    website_url: '' // Honeypot field
  });

  const [files, setFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null
  const [submissionId, setSubmissionId] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // FAQ accordion state
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  // Handle text/select/radio changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Handle file uploads
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    
    const maxFiles = 5;
    const maxSingleSize = 10 * 1024 * 1024; // 10 MB
    const maxTotalSize = 20 * 1024 * 1024; // 20 MB
    const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/gif', 'image/webp'];

    if (files.length + selectedFiles.length > maxFiles) {
      alert(lt('alert_max_files'));
      return;
    }

    let currentTotalSize = files.reduce((sum, f) => sum + f.size, 0);
    const validFiles = [];

    for (const file of selectedFiles) {
      if (!allowedTypes.includes(file.type)) {
        alert(lt('alert_invalid_type'));
        continue;
      }

      if (file.size > maxSingleSize) {
        alert(lt('alert_file_too_large'));
        continue;
      }

      if (currentTotalSize + file.size > maxTotalSize) {
        alert(lt('alert_total_size'));
        break;
      }

      currentTotalSize += file.size;
      validFiles.push(file);
    }

    setFiles((prev) => [...prev, ...validFiles]);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const removeFile = (indexToRemove) => {
    setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side validations
    if (files.length < 3) {
      alert(lt('alert_min_images'));
      return;
    }

    if (formData.math_answer !== '60') {
      alert(lt('alert_wrong_math'));
      return;
    }

    if (!formData.samtykke) {
      alert(lt('alert_consent'));
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);
    setErrorMessage('');

    try {
      const data = new FormData();
      
      // Append all fields with the exact Danish keys expected by the backend
      data.append('stelnummer_eller_registreringsnummer', formData.stelnummer_eller_reg);
      data.append('kilometer_norm_paa_bilen', formData.kilometer_norm);
      data.append('udstyrsvariant_farver_mm', formData.udstyrsvariant_farver);
      data.append('bilens_placering', formData.bilens_placering);
      data.append('registreringsland', formData.registreringsland);
      data.append('er_bilen_ekskl_registreringsafgift', formData.ekskl_registreringsafgift);
      data.append('er_bilen_moms_eller_momsfri', formData.moms_status);
      data.append('mekanisk_eller_elektrisk_fejl', formData.mekanisk_elektrisk_fejl);
      data.append('status_paa_forruden', formData.forrude_status);
      data.append('antal_felter_til_lak', formData.lak_felter);
      data.append('kan_koeretoejet_bremse_koere_osv', formData.autotransport_egnet);
      data.append('bemaerkninger', formData.bemaerkninger);
      data.append('navn', formData.navn);
      data.append('telefon', formData.telefon);
      data.append('email', formData.email);
      data.append('website_url', formData.website_url); // Honeypot

      // Append files
      files.forEach((file) => {
        data.append('filer', file);
      });

      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        body: data
      });

      const result = await response.json();

      if (response.ok && result.status === 'ok') {
        setSubmitStatus('success');
        setSubmissionId(result.submissionId);
        // Reset form
        setFormData({
          stelnummer_eller_reg: '',
          kilometer_norm: '',
          udstyrsvariant_farver: '',
          bilens_placering: '',
          registreringsland: '',
          ekskl_registreringsafgift: '',
          moms_status: '',
          mekanisk_elektrisk_fejl: '',
          forrude_status: '',
          lak_felter: '',
          autotransport_egnet: '',
          bemaerkninger: '',
          navn: '',
          telefon: '',
          email: '',
          math_answer: '',
          samtykke: false,
          website_url: ''
        });
        setFiles([]);
      } else {
        setSubmitStatus('error');
        setErrorMessage(result.message || lt('default_error'));
      }
    } catch (error) {
      setSubmitStatus('error');
      setErrorMessage(lt('network_error'));
    } finally {
      setIsSubmitting(false);
    }
  };

  // Get localized reviews and FAQs
  const reviews = localizedReviews[language] || localizedReviews['da'];
  const faqs = localizedFaqs[language] || localizedFaqs['da'];

  return (
    <div className="pt-44 md:pt-52 pb-24 bg-slate-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-xs font-bold text-slate-500 hover:text-slate-900 transition-colors uppercase tracking-wider mb-8 cursor-pointer"
        >
          <ArrowLeft className="h-4 w-4" />
          {lt('back')}
        </button>

        {/* Form Section */}
        <div className="w-full">
          {submitStatus === 'success' ? (
            <div className="bg-white border border-slate-200 p-8 md:p-12 text-center shadow-2xl shadow-slate-300/60 rounded-none animate-fade-in">
              <div className="inline-flex items-center justify-center h-16 w-16 bg-emerald-50 text-emerald-600 mb-6">
                <CheckCircle2 className="h-10 w-10" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black italic text-[#293e30] uppercase tracking-tight mb-4">
                {lt('success_title')}
              </h2>
              <p className="text-slate-600 max-w-lg mx-auto mb-8 text-sm md:text-base leading-relaxed">
                {lt('success_desc')}
              </p>
              <div className="bg-slate-50 p-4 border border-slate-100 inline-block mb-8 text-left">
                <p className="text-xs text-slate-400 uppercase tracking-widest font-bold">{lt('ref_id')}</p>
                <p className="text-sm font-mono font-bold text-slate-800">{submissionId}</p>
              </div>
              <div>
                <button
                  onClick={() => setSubmitStatus(null)}
                  className="inline-flex items-center justify-center px-8 py-3.5 bg-black hover:bg-slate-900 text-white text-xs font-bold tracking-wider uppercase rounded-none transition-all cursor-pointer"
                >
                  {lt('submit_new')}
                </button>
              </div>
            </div>
          ) : (
            <div className="bg-white border border-slate-200 shadow-2xl shadow-slate-300/60 rounded-none overflow-hidden">
              
              {/* Form Header */}
              <div className="bg-[#293e30] text-white p-8 md:p-12 relative overflow-hidden">
                <div className="absolute inset-0 bg-[#293e30]"></div>
                <div className="relative z-10">
                  <h1 className="text-2xl sm:text-3xl md:text-4xl font-black italic uppercase tracking-tight leading-tight max-w-2xl">
                    {lt('form_title')}
                  </h1>
                  <p className="text-[#f1f1f1] text-xs sm:text-sm mt-4 max-w-xl leading-relaxed">
                    {lt('form_desc')}
                  </p>
                </div>
              </div>

              {/* Form Body */}
              <form onSubmit={handleSubmit} className="p-6 md:p-12 space-y-8">
                
                {/* Anti-spam Honeypot Field */}
                <div className="sr-only absolute">
                  <label htmlFor="website_url">{lt('honeypot_label')}</label>
                  <input
                    type="text"
                    id="website_url"
                    name="website_url"
                    value={formData.website_url}
                    onChange={handleInputChange}
                    tabIndex="-1"
                    autoComplete="off"
                  />
                </div>

                {/* Error Message */}
                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-100 p-4 text-red-700 flex items-start gap-3 rounded-none">
                    <AlertCircle className="h-5 w-5 shrink-0 mt-0.5" />
                    <div className="text-sm">
                      <p className="font-bold">{lt('error_occurred')}</p>
                      <p>{errorMessage}</p>
                    </div>
                  </div>
                )}

                {/* SECTION 1: BILENS BASISOPLYSNINGER */}
                <div className="space-y-6">
                  <h3 className="text-sm font-black italic text-[#293e30] uppercase tracking-wider border-b border-slate-100 pb-2">
                    {lt('sec1_title')}
                  </h3>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Stelnummer eller registreringsnummer */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('vin_label')}
                      </label>
                      <input
                        type="text"
                        name="stelnummer_eller_reg"
                        required
                        value={formData.stelnummer_eller_reg}
                        onChange={handleInputChange}
                        placeholder={lt('vin_placeholder')}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      />
                    </div>

                    {/* Kilometer-norm på bilen */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('km_label')}
                      </label>
                      <input
                        type="number"
                        name="kilometer_norm"
                        required
                        value={formData.kilometer_norm}
                        onChange={handleInputChange}
                        placeholder={lt('km_placeholder')}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Bilens placering */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('location_label')}
                      </label>
                      <input
                        type="text"
                        name="bilens_placering"
                        required
                        value={formData.bilens_placering}
                        onChange={handleInputChange}
                        placeholder={lt('location_placeholder')}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      />
                    </div>

                    {/* Registreringsland */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('country_label')}
                      </label>
                      <select
                        name="registreringsland"
                        required
                        value={formData.registreringsland}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      >
                        <option value="">{lt('country_choose')}</option>
                        <option value="Danmark">{lt('country_dk')}</option>
                        <option value="Sverige">{lt('country_se')}</option>
                        <option value="Tyskland">{lt('country_de')}</option>
                        <option value="Ikke et europæisk land">{lt('country_non_eu')}</option>
                      </select>
                    </div>
                  </div>

                  {/* Udstyrsvariant, farver m.m. */}
                  <div className="space-y-2">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      {lt('equip_label')}
                    </label>
                    <textarea
                      name="udstyrsvariant_farver"
                      required
                      rows="3"
                      value={formData.udstyrsvariant_farver}
                      onChange={handleInputChange}
                      placeholder={lt('equip_placeholder')}
                      className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50 resize-none"
                    ></textarea>
                  </div>
                </div>

                {/* SECTION 2: AFGIFT & MOMS STATUS */}
                <div className="space-y-6">
                  <h3 className="text-sm font-black italic text-[#293e30] uppercase tracking-wider border-b border-slate-100 pb-2">
                    {lt('sec2_title')}
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Er bilen ekskl. registreringsafgift? */}
                    <div className="space-y-3">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('ex_tax_label')}
                      </label>
                      <div className="space-y-2">
                        <label className="flex items-start gap-3 p-3 border border-slate-100 bg-slate-50/30 hover:bg-slate-50 cursor-pointer transition-colors">
                          <input
                            type="radio"
                            name="ekskl_registreringsafgift"
                            required
                            value="Ekskl. registreringsafgift - Ekskl. moms"
                            checked={formData.ekskl_registreringsafgift === 'Ekskl. registreringsafgift - Ekskl. moms'}
                            onChange={handleInputChange}
                            className="mt-1 text-[#293e30] focus:ring-[#293e30]"
                          />
                          <span className="text-xs text-slate-700 font-medium">
                            {lt('ex_tax_opt1')}
                          </span>
                        </label>
                        <label className="flex items-start gap-3 p-3 border border-slate-100 bg-slate-50/30 hover:bg-slate-50 cursor-pointer transition-colors">
                          <input
                            type="radio"
                            name="ekskl_registreringsafgift"
                            required
                            value="Ekskl. registreringsafgift"
                            checked={formData.ekskl_registreringsafgift === 'Ekskl. registreringsafgift'}
                            onChange={handleInputChange}
                            className="mt-1 text-[#293e30] focus:ring-[#293e30]"
                          />
                          <span className="text-xs text-slate-700 font-medium">
                            {lt('ex_tax_opt2')}
                          </span>
                        </label>
                        <label className="flex items-start gap-3 p-3 border border-red-100 bg-red-50/10 hover:bg-red-50/30 cursor-pointer transition-colors">
                          <input
                            type="radio"
                            name="ekskl_registreringsafgift"
                            required
                            value="Inklusive registreringsafgift - dem køber vi ikke"
                            checked={formData.ekskl_registreringsafgift === 'Inklusive registreringsafgift - dem køber vi ikke'}
                            onChange={handleInputChange}
                            className="mt-1 text-red-600 focus:ring-red-600"
                          />
                          <span className="text-xs text-red-700 font-semibold">
                            {lt('ex_tax_opt3')}
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* Er bilen + Moms, eller Momsfri? */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('vat_label')}
                      </label>
                      <select
                        name="moms_status"
                        required
                        value={formData.moms_status}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      >
                        <option value="">{lt('vat_choose')}</option>
                        <option value="Med 25% løftbar moms">{lt('vat_opt1')}</option>
                        <option value="Momsdød - momsfri, ingen adgang til momsfradrag">{lt('vat_opt2')}</option>
                      </select>
                      <div className="p-3 bg-emerald-50/50 border border-emerald-100/50 text-[11px] text-[#293e30] leading-relaxed flex gap-2">
                        <Info className="h-4 w-4 shrink-0 mt-0.5 text-[#293e30]" />
                        <span>{lt('info_box')}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* SECTION 3: BILENS STAND */}
                <div className="space-y-6">
                  <h3 className="text-sm font-black italic text-[#293e30] uppercase tracking-wider border-b border-slate-100 pb-2">
                    {lt('sec3_title')}
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Mekanisk eller elektrisk fejl? */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('mech_label')}
                      </label>
                      <select
                        name="mekanisk_elektrisk_fejl"
                        required
                        value={formData.mekanisk_elektrisk_fejl}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      >
                        <option value="">{lt('mech_choose')}</option>
                        <option value="Har mekanisk fejl">{lt('mech_opt1')}</option>
                        <option value="Har elektrisk fejl">{lt('mech_opt2')}</option>
                        <option value="Bilen har ikke mekanisk eller elektrisk fejl">{lt('mech_opt3')}</option>
                      </select>
                    </div>

                    {/* Hvad er status på forruden? */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('windshield_label')}
                      </label>
                      <select
                        name="forrude_status"
                        required
                        value={formData.forrude_status}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      >
                        <option value="">{lt('windshield_choose')}</option>
                        <option value="Fejlfri">{lt('windshield_opt1')}</option>
                        <option value="Stenslag">{lt('windshield_opt2')}</option>
                        <option value="Flænge">{lt('windshield_opt3')}</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Hvor mange felter til lak? */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('paint_label')}
                      </label>
                      <select
                        name="lak_felter"
                        required
                        value={formData.lak_felter}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      >
                        <option value="">{lt('paint_choose')}</option>
                        <option value="0 - Som ny bil!">{lt('paint_opt0')}</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                      </select>
                    </div>

                    {/* Kan køretøjet bremse, håndbremse, køre og bakke på autotransport? */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('transport_label')}
                      </label>
                      <select
                        name="autotransport_egnet"
                        required
                        value={formData.autotransport_egnet}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      >
                        <option value="">{lt('transport_choose')}</option>
                        <option value="Ja">{lt('transport_yes')}</option>
                        <option value="Nej - (Auto Logik A/S - MED SPIL VOGN)">{lt('transport_no')}</option>
                      </select>
                    </div>
                  </div>

                  {/* Bemærkninger */}
                  <div className="space-y-2">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      {lt('remarks_label')}
                    </label>
                    <textarea
                      name="bemaerkninger"
                      rows="3"
                      value={formData.bemaerkninger}
                      onChange={handleInputChange}
                      placeholder={lt('remarks_placeholder')}
                      className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50 resize-none"
                    ></textarea>
                  </div>
                </div>

                {/* SECTION 4: UPLOAD BILLEDER */}
                <div className="space-y-6">
                  <div className="border-b border-slate-100 pb-2 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                    <h3 className="text-sm font-black italic text-[#293e30] uppercase tracking-wider">
                      {lt('sec4_title')}
                    </h3>
                  </div>

                  {/* File Upload Box */}
                  <div 
                    onClick={() => fileInputRef.current?.click()}
                    className="border-2 border-dashed border-slate-200 hover:border-[#293e30] bg-slate-50/50 hover:bg-slate-50 p-8 text-center cursor-pointer transition-all group rounded-none"
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      multiple
                      accept=".pdf,.png,.jpg,.jpeg,.gif,.webp"
                      className="hidden"
                    />
                    <div className="flex flex-col items-center gap-3">
                      <div className="h-12 w-12 bg-white border border-slate-100 flex items-center justify-center text-slate-400 group-hover:text-[#293e30] transition-colors shadow-sm">
                        <Camera className="h-6 w-6" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-slate-700 uppercase tracking-wider">
                          {lt('upload_click')}
                        </p>
                        <p className="text-[11px] text-slate-400 mt-1">
                          {lt('upload_desc')}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* File Previews */}
                  {files.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                      {files.map((file, index) => (
                        <div 
                          key={index}
                          className="flex items-center justify-between p-3 border border-slate-200 bg-white shadow-sm rounded-none"
                        >
                          <div className="flex items-center gap-3 min-w-0">
                            <FileText className="h-5 w-5 text-slate-400 shrink-0" />
                            <div className="min-w-0">
                              <p className="text-xs font-bold text-slate-700 truncate">{file.name}</p>
                              <p className="text-[10px] text-slate-400">{(file.size / (1024 * 1024)).toFixed(2)} MB</p>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeFile(index);
                            }}
                            className="p-1 text-slate-400 hover:text-red-600 transition-colors cursor-pointer"
                            aria-label={lt('remove_file')}
                          >
                            <X className="h-4 w-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* SECTION 5: KONTAKTOPLYSNINGER */}
                <div className="space-y-6">
                  <h3 className="text-sm font-black italic text-[#293e30] uppercase tracking-wider border-b border-slate-100 pb-2">
                    {lt('sec5_title')}
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {/* Navn */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('name_label')}
                      </label>
                      <input
                        type="text"
                        name="navn"
                        required
                        value={formData.navn}
                        onChange={handleInputChange}
                        placeholder={lt('name_placeholder')}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      />
                    </div>

                    {/* Telefon */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('phone_label')}
                      </label>
                      <input
                        type="tel"
                        name="telefon"
                        required
                        value={formData.telefon}
                        onChange={handleInputChange}
                        placeholder={lt('phone_placeholder')}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      />
                    </div>

                    {/* Email */}
                    <div className="space-y-2">
                      <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                        {lt('email_label')}
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder={lt('email_placeholder')}
                        className="w-full px-4 py-3 border border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none bg-slate-50/50"
                      />
                    </div>
                  </div>
                </div>

                {/* SECTION 6: SIKKERHED & SAMTYKKE */}
                <div className="space-y-6 pt-4 border-t border-slate-100">
                  
                  {/* Math Verification */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center bg-slate-50 p-6 border border-slate-100">
                    <div className="space-y-1">
                      <label className="block text-xs font-black italic text-[#293e30] uppercase tracking-wider">
                        {lt('sec6_title')}
                      </label>
                      <p className="text-[11px] text-slate-500">
                        {lt('math_desc')}
                      </p>
                    </div>
                    <div>
                      <select
                        name="math_answer"
                        required
                        value={formData.math_answer}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-slate-200 bg-white focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none text-sm transition-all rounded-none"
                      >
                        <option value="">{lt('math_choose')}</option>
                        <option value="60">60</option>
                        <option value="58">58</option>
                        <option value="61">61</option>
                        <option value="59">59</option>
                      </select>
                    </div>
                  </div>

                  {/* Consent Checkbox */}
                  <div className="space-y-4">
                    <label className="flex items-start gap-3 cursor-pointer select-none">
                      <input
                        type="checkbox"
                        name="samtykke"
                        required
                        checked={formData.samtykke}
                        onChange={handleInputChange}
                        className="mt-1 h-4 w-4 text-[#293e30] focus:ring-[#293e30] border-slate-300 rounded-none cursor-pointer"
                      />
                      <span className="text-xs text-slate-600 leading-relaxed">
                        {lt('consent_text')}
                      </span>
                    </label>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="pt-4">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 bg-black hover:bg-slate-900 text-white font-bold text-sm tracking-wider uppercase rounded-none transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <Loader2 className="h-4 w-4 animate-spin" />
                        {lt('submitting')}
                      </>
                    ) : (
                      lt('submit_btn')
                    )}
                  </button>
                </div>

              </form>
            </div>
          )}

          {/* Security / Trust Badge */}
          <div className="mt-8 flex items-center justify-center gap-2 text-xs text-slate-400">
            <ShieldCheck className="h-4 w-4 text-emerald-600" />
            <span>{lt('secure_data')}</span>
          </div>
        </div>

        {/* REVIEWS SECTION: VI LADER KUNDER SNAKKE FOR OS... */}
        <section className="mt-24 border-t border-slate-200 pt-16">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black italic text-[#293e30] uppercase tracking-tight mb-4">
              {lt('reviews_title')}
            </h2>
            <div className="flex items-center justify-center gap-1 text-[#f6bb06] mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-current" />
              ))}
            </div>
            <p className="text-slate-600 text-sm md:text-base">
              {lt('reviews_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review, index) => (
              <div 
                key={index} 
                className="bg-white border border-slate-200 p-6 shadow-lg shadow-slate-100/50 flex flex-col justify-between rounded-none"
              >
                <p className="text-slate-600 text-xs sm:text-sm leading-relaxed italic mb-6">
                  "{review.text}"
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                  <img 
                    src={review.img} 
                    alt={review.name} 
                    className="h-10 w-10 rounded-full object-cover shrink-0"
                  />
                  <div>
                    <h4 className="text-xs font-bold text-slate-900 uppercase tracking-wider">{review.name}</h4>
                    <p className="text-[10px] text-slate-400">{review.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ SECTION: FÅ SVAR PÅ DINE SPØRGSMÅL... */}
        <section className="mt-24 border-t border-slate-200 pt-16 max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black italic text-[#293e30] uppercase tracking-tight">
              {lt('faq_title')}
            </h2>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => {
              const isOpen = openFaqIndex === index;
              return (
                <div 
                  key={index}
                  className="bg-white border border-slate-200 shadow-sm transition-all rounded-none overflow-hidden"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full flex items-center justify-between p-5 text-left font-bold text-slate-800 hover:text-slate-900 transition-colors focus:outline-none cursor-pointer"
                  >
                    <span className="text-xs sm:text-sm uppercase tracking-wider leading-snug">
                      - {faq.q}
                    </span>
                    {isOpen ? (
                      <ChevronUp className="h-4 w-4 shrink-0 text-slate-500" />
                    ) : (
                      <ChevronDown className="h-4 w-4 shrink-0 text-slate-500" />
                    )}
                  </button>
                  
                  {isOpen && (
                    <div className="px-5 pb-6 border-t border-slate-100 pt-4">
                      <div 
                        className="prose prose-slate max-w-none text-xs sm:text-sm text-slate-600 leading-relaxed space-y-4
                          prose-h3:text-sm prose-h3:font-black prose-h3:italic prose-h3:text-[#293e30] prose-h3:uppercase prose-h3:tracking-wider prose-h3:mb-2
                          prose-h4:text-xs prose-h4:font-bold prose-h4:text-slate-800 prose-h4:uppercase prose-h4:tracking-wider prose-h4:mt-4 prose-h4:mb-2
                          prose-ul:list-disc prose-ul:pl-5 prose-ul:space-y-1
                          prose-ol:list-decimal prose-ol:pl-5 prose-ol:space-y-1"
                        dangerouslySetInnerHTML={{ __html: faq.a }}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Direct Contact CTA */}
          <div className="mt-12 bg-[#293e30] text-white p-8 text-center relative overflow-hidden rounded-none">
            <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#76eeda_1px,transparent_1px)] [background-size:16px_16px]"></div>
            <div className="relative z-10 space-y-4">
              <h3 className="text-lg sm:text-xl font-black italic uppercase tracking-wider">
                {lt('cta_title')}
              </h3>
              <p className="text-slate-300 text-xs sm:text-sm max-w-xl mx-auto leading-relaxed">
                {lt('cta_desc')}
              </p>
              <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
                <a 
                  href="/kontakt" 
                  className="inline-flex items-center gap-2 px-6 py-3 bg-[#76eeda] hover:bg-[#5cdbc7] text-black font-bold text-sm tracking-wider uppercase rounded-none transition-all w-full sm:w-auto justify-center"
                >
                  {lt('cta_btn')}
                </a>
                <a 
                  href="tel:+4560133473" 
                  className="inline-flex items-center gap-2 px-6 py-3 bg-white hover:bg-slate-100 text-black font-bold text-sm tracking-wider uppercase rounded-none transition-all w-full sm:w-auto justify-center"
                >
                  <Phone className="h-4 w-4 text-[#293e30]" />
                  60 13 34 73
                </a>
              </div>
            </div>
          </div>

        </section>

      </div>
    </div>
  );
}
